export const environment = {
  production: true,
  buildId: '2794513783819051',
  configFile: 'config.json',
};
